import { useState } from "react";

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    "your-name": "",
    "your-email": "",
    "your-message": "",
    "gdprConsent": false,
  });

  const [submitMessage, setSubmitMessage] = useState<null | {
    code: number;
    message: string;
  }>(null);

  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSubmitMessage(null);

    // Dôležité: Používame FormData, pretože CF7 REST API očakáva multipart/form-data
    const body = new FormData();
    body.append("your-name", formData["your-name"]);
    body.append("your-email", formData["your-email"]);
    body.append("your-message", formData["your-message"]);
    
    // CF7 očakáva pri acceptance poli hodnotu "1" (string), ak je zaškrtnuté
    if (formData.gdprConsent) {
      body.append("gdprConsent", "1");
    }

    // Unit tag pomáha CF7 identifikovať inštanciu, ID 40 je vaše hlavné ID
    body.append("_wpcf7_unit_tag", "wpcf7-f40-p1-o1");

    try {
      const res = await fetch(
        "https://veridian.adam-webdev.sk/wp-json/contact-form-7/v1/contact-forms/40/feedback",
        {
          method: "POST",
          body: body,
          // ŽIADNE HEADERS! Prehliadač si ich nastaví sám pre FormData.
        }
      );

      const result = await res.json();

      if (result.status === "mail_sent") {
        setSubmitMessage({
          code: 200,
          message: "Správa bola úspešne odoslaná.",
        });
        setFormData({
          "your-name": "",
          "your-email": "",
          "your-message": "",
          "gdprConsent": false,
        });
      } else {
        // Ak result.status nie je mail_sent (napr. validation_failed)
        setSubmitMessage({
          code: 400,
          message: result.message || "Nepodarilo sa odoslať formulár. Skontrolujte údaje.",
        });
      }
    } catch (err) {
      setSubmitMessage({
        code: 500,
        message: "Chyba pripojenia k serveru.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-5 mt-4">
      <div className="col-span-2 md:col-span-1">
        <input
          type="text"
          name="your-name"
          placeholder="Meno *"
          value={formData["your-name"]}
          onChange={handleChange}
          required
          className="w-full border-2 rounded-lg py-2 px-4"
        />
      </div>

      <div className="col-span-2 md:col-span-1">
        <input
          type="email"
          name="your-email"
          placeholder="Email *"
          value={formData["your-email"]}
          onChange={handleChange}
          required
          className="w-full border-2 rounded-lg py-2 px-4"
        />
      </div>

      <div className="col-span-2">
        <textarea
          name="your-message"
          placeholder="Správa (voliteľné)"
          value={formData["your-message"]}
          onChange={handleChange}
          className="w-full border-2 rounded-lg py-2 px-4 h-32"
        />
      </div>

      <div className="col-span-2 flex items-center gap-2">
        <input
          type="checkbox"
          id="gdpr"
          name="gdprConsent"
          checked={formData.gdprConsent}
          onChange={handleChange}
          required
        />
        <label htmlFor="gdpr" className="text-sm cursor-pointer">
          Súhlasím so spracovaním osobných údajov <span className="text-red-500">*</span>
        </label>
      </div>

      <div className="col-span-2">
        <button
          type="submit"
          disabled={loading}
          className="bg-black text-white px-8 py-3 rounded hover:bg-gray-800 disabled:bg-gray-400 transition-colors"
        >
          {loading ? "Odosielam..." : "Odoslať"}
        </button>
      </div>

      {submitMessage && (
        <div className={`col-span-2 p-3 rounded text-white ${submitMessage.code === 200 ? 'bg-green-500' : 'bg-red-500'}`}>
          {submitMessage.message}
        </div>
      )}
    </form>
  );
};